import React from 'react';

import { getTimeAgoString } from '../../../../../core/utils/time/time-utils.js';

type TimestampProps = {
  updated: string;
  published: string;
  onlyShowPublishedDate?: boolean;
  forTeaserCard?: boolean;
};

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  year: 'numeric',
  month: '2-digit',
};

const monthFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
};

const anHourInMs = 1000 * 60 * 60;
const threeHoursInMs = 3 * anHourInMs;

function timestampString(updated: string, published: string): string {
  const updatedDate = new Date(updated);
  const publishedDate = new Date(published);
  const rightNow = new Date();

  const timeStamp =
    publishedDate.getTime() < updatedDate.getTime()
      ? updatedDate
      : publishedDate;

  const diff = rightNow.getTime() - updatedDate.getTime();
  const is4HoursOrLess = diff <= threeHoursInMs;

  if (!is4HoursOrLess) {
    return updatedDate.toLocaleDateString('no-NO', dateFormatOptions);
  }
  const str = getTimeAgoString(timeStamp);
  if (isNaN(parseInt(str[0], 10))) {
    return str[0] + str.slice(1);
  }

  return str;
}

const publishedDateString = (published: string, forTeaserCard?: boolean) => {
  const publishedDate = new Date(published);
  const formattedDate = forTeaserCard
    ? publishedDate.toLocaleDateString('no-NO', monthFormatOptions)
    : publishedDate.toLocaleDateString('no-NO', dateFormatOptions);

  return formattedDate;
};

const isUpdated = (published: string, updated: string) => {
  const updatedDate = new Date(updated);
  const publishedDate = new Date(published);
  const isUpdated = publishedDate.getTime() < updatedDate.getTime();

  return isUpdated;
};

const TimeStamp: React.FC<TimestampProps> = ({
  published,
  updated,
  forTeaserCard,
}) => {
  const publishedString = publishedDateString(published, forTeaserCard);
  const updatedString = timestampString(updated, published);

  return (
    <div className="time-stamp">
      <time
        aria-label={`Publisert: ${publishedString} Oppdatert: ${updatedString}`}
      >
        {forTeaserCard ? (
          <>Anmeldt: {publishedString} </>
        ) : (
          <>Publisert: {publishedString} </>
        )}
        {isUpdated(published, updated) && (
          <> |&nbsp;Oppdatert: {updatedString}</>
        )}
      </time>
    </div>
  );
};
export default TimeStamp;
